import { letterSectionId } from '@/lib/vocabularyGrouping'

function stickyHeaderOffset(card: HTMLElement): number {
  const sticky = card.closest('section')?.querySelector<HTMLElement>('.sticky')
  if (!sticky) return 16
  return Math.ceil(sticky.offsetHeight) + 12
}

function alignCardInScroller(scroller: HTMLElement, el: HTMLElement) {
  const offset = stickyHeaderOffset(el)
  const sRect = scroller.getBoundingClientRect()
  const eRect = el.getBoundingClientRect()
  scroller.scrollTop = Math.max(0, eRect.top - sRect.top + scroller.scrollTop - offset)
}

function alignCardInOuterScrollers(el: HTMLElement) {
  const marginTop = 12
  const marginBottom = 96
  const rect = el.getBoundingClientRect()

  const main = document.querySelector<HTMLElement>('main')
  const overflowY = main ? getComputedStyle(main).overflowY : ''
  const mainScrolls =
    !!main
    && main.scrollHeight > main.clientHeight + 1
    && (overflowY === 'auto' || overflowY === 'scroll')

  if (mainScrolls && main) {
    const mRect = main.getBoundingClientRect()
    if (rect.top < mRect.top + marginTop || rect.bottom > mRect.bottom - marginTop) {
      main.scrollTop = Math.max(
        0,
        rect.top - mRect.top + main.scrollTop - Math.max(marginTop, main.clientHeight * 0.12),
      )
    }
    return
  }

  if (rect.top < marginTop || rect.bottom > window.innerHeight - marginBottom) {
    window.scrollTo(0, Math.max(0, window.scrollY + rect.top - Math.max(marginTop, window.innerHeight * 0.12)))
  }
}

/**
 * Scroll the vocabulary list (and outer page scrollers on mobile) to a word card.
 * Returns true when the card was found in the DOM.
 */
export function scrollVocabularyItemIntoView(
  userWordId: string,
  listContainer: HTMLElement | null,
): boolean {
  const el = document.querySelector<HTMLElement>(
    `[data-user-word-id="${CSS.escape(userWordId)}"]`,
  )
  if (!el) return false

  if (listContainer) {
    alignCardInScroller(listContainer, el)
  }

  // Nudge window/main when they are the real scroller (common on mobile).
  el.scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'auto' })

  // Re-apply list alignment after scrollIntoView (sticky group headers).
  if (listContainer) {
    alignCardInScroller(listContainer, el)
  }
  alignCardInOuterScrollers(el)

  return true
}

/** Fallback when the card is not on the loaded page: jump to its letter section. */
export function scrollVocabularyLetterIntoView(surface: string): boolean {
  const raw = surface.trim().charAt(0).toUpperCase()
  const letter = /[A-ZА-ЯЁ]/i.test(raw) ? raw : '#'
  const section = document.getElementById(letterSectionId(letter))
  if (!section) return false
  section.scrollIntoView({ block: 'start', behavior: 'auto' })
  return true
}
